/**
 * FH batch 19 (2026-09-26): collection filter sidebar, group order from the agency design:
 * Material, Size, Price, Color, then any others, with Brand last. The groups are really moved in the
 * page (not only drawn in a different place), so the Tab key and screen readers follow the order you
 * see. Re-applied whenever the filter app redraws the sidebar. Styling is in ada-collection-sidebar.css.
 * Rollback: remove the batch 19 lines at the end of snippets/freshdesk.liquid.
 */
(function () {
  'use strict';
  if (window.__fhBatch19) return;
  window.__fhBatch19 = true;

  var ORDER = { material: 1, size: 2, price: 3, color: 4, colour: 4, brand: 99 };
  function rank(block) {
    /* The heading's own text only (an active filter adds a "Clear" link next to it). */
    var el = block.querySelector('.gf-block-title .h3 > span') || block.querySelector('.gf-block-title') || block;
    var t = el.textContent.replace(/\bclear\b/ig, '').replace(/\s+/g, ' ').trim().toLowerCase();
    return ORDER.hasOwnProperty(t) ? ORDER[t] : 50;
  }

  function reorder() {
    var box = document.querySelector('#gf-tree .gf-filter-contents');
    if (!box) return;
    var blocks = Array.prototype.filter.call(box.children, function (c) { return c.classList.contains('gf-option-block'); });
    if (blocks.length < 2) return;
    var sorted = blocks.slice().sort(function (a, b) {
      return (rank(a) - rank(b)) || (blocks.indexOf(a) - blocks.indexOf(b));
    });
    var same = sorted.every(function (b, i) { return b === blocks[i]; });
    if (same) return;
    var active = document.activeElement;
    var marker = document.createComment('fh-order');
    box.insertBefore(marker, blocks[0]);
    sorted.forEach(function (b) { box.insertBefore(b, marker); });
    box.removeChild(marker);
    /* Moving an element can drop keyboard focus: put it back. */
    if (active && active !== document.activeElement && active.isConnected && box.contains(active)) {
      try { active.focus({ preventScroll: true }); } catch (e) { active.focus(); }
    }
  }

  /* Desktop: the collection banner sits to the right of the sidebar, which left an empty white box above
     MATERIAL. Colour that box like the page (#FAFAFA) and start the filters right under the header, as in
     the agency design. Phones / the filter drawer are left alone. */
  function align() {
    var tree = document.getElementById('gf-tree');
    var grid = document.querySelector('.shopify-section:has(#gf-tree)') || (tree && tree.closest('.shopify-section'));
    if (!tree || !grid) return;
    var prev = grid.previousElementSibling;
    while (prev && !(prev.classList.contains('shopify-section') && prev.getBoundingClientRect().height > 0)) prev = prev.previousElementSibling;
    var banner = prev && prev.querySelector('.banner, .slideshow');
    var desktop = window.innerWidth >= 990 && getComputedStyle(tree).position !== 'fixed' && tree.getBoundingClientRect().width > 0;
    /* The filter app rewrites the sidebar's own style, so the offset is kept on the section around it (a CSS
       variable plus a class) and the stylesheet applies it with priority. */
    var cur = parseFloat(grid.style.getPropertyValue('--fh-raise')) || 0;
    var on = grid.classList.contains('fh-gf-raised');
    function reset() { grid.style.removeProperty('--fh-raise'); grid.classList.remove('fh-gf-raised'); }
    if (!desktop || !banner) { if (cur || on) reset(); return; }
    var tr = tree.getBoundingClientRect();
    var br = banner.getBoundingClientRect();
    if (br.left < tr.right) { if (cur || on) reset(); return; }
    /* Colour set by class: an older stylesheet forces this section transparent (see ada-collection-sidebar.css). */
    if (!prev.classList.contains('fh-banner-fill')) prev.classList.add('fh-banner-fill');
    var applied = on ? cur : 0;
    /* Measure from the product grid next to the sidebar, which we never move, so the result can't feed
       back into itself (the first version measured the sidebar and could run away, making it bounce). */
    var ref = document.getElementById('gf-grid');
    if (!ref || !ref.getBoundingClientRect().height) { if (cur || on) reset(); return; }
    var naturalTop = ref.getBoundingClientRect().top;  /* where the sidebar starts without our change */
    var want = br.top + 40;                             /* 40px under the header, like the design */
    var m = Math.round(want - naturalTop);
    if (m >= 0 || m < -(br.height + 80)) m = 0;         /* only ever pull up by about the banner's height */
    if (!m) { if (cur || on) reset(); return; }
    if (Math.abs(m - applied) > 1 || !on) {
      grid.style.setProperty('--fh-raise', m + 'px');
      grid.classList.add('fh-gf-raised');
    }
  }

  /* axe fixes (Sep 27):
     - sold-out sizes on an open product card can't be chosen, so say so (aria-disabled); they are also restyled to
       readable grey text in ada-collection-sidebar.css (they were faded to 1.8:1);
     - the menu app's inner <nav> is set to role="none" by batch 8 (so the main menu isn't announced twice), but its
       aria-label made browsers ignore that role (axe "presentation-role-conflict"): drop the label there. */
  function axeFixes() {
    document.querySelectorAll('.spf-product__swatch[role="radio"]').forEach(function (s) {
      var off = s.classList.contains('soldout');
      if (off && s.getAttribute('aria-disabled') !== 'true') s.setAttribute('aria-disabled', 'true');
      if (!off && s.hasAttribute('aria-disabled')) s.removeAttribute('aria-disabled');
    });
    document.querySelectorAll('nav.tmenu_navbar[role="none"][aria-label]').forEach(function (n) { n.removeAttribute('aria-label'); });
  }

  /* FH 2026-09-29: after the window is resized (for example from a narrow window back to full width), the page
     keeps settling for a moment while the filter app turns the drawer back into the sidebar. The check above could
     run before that finished and leave the filters below the banner. So: check again once the resize settles, and
     whenever the sidebar, the product grid or the banner changes size. */
  var sizeWatch = ('ResizeObserver' in window) ? new ResizeObserver(function () { schedule(); }) : null;
  var watched = [];
  function watch() {
    if (!sizeWatch) return;
    var tree = document.getElementById('gf-tree');
    var grid = tree && tree.closest('.shopify-section');
    var prev = grid && grid.previousElementSibling;
    while (prev && !prev.classList.contains('shopify-section')) prev = prev.previousElementSibling;
    [tree, document.getElementById('gf-grid'), prev && prev.querySelector('.banner, .slideshow')].forEach(function (el) {
      if (el && watched.indexOf(el) < 0) { watched.push(el); sizeWatch.observe(el); }
    });
    watched = watched.filter(function (el) {
      if (el.isConnected) return true;
      sizeWatch.unobserve(el);
      return false;
    });
  }

  var timer = 0;
  var settle = 0;
  function schedule() {
    if (timer) return;
    timer = setTimeout(function () { timer = 0; try { reorder(); } catch (e) {} try { align(); } catch (e) {} try { axeFixes(); } catch (e) {} try { watch(); } catch (e) {} }, 30);
  }
  function onResize() {
    schedule();
    clearTimeout(settle);
    settle = setTimeout(schedule, 400);
  }
  function start() {
    reorder();
    try { align(); } catch (e) {}
    try { axeFixes(); } catch (e) {}
    try { watch(); } catch (e) {}
    window.addEventListener('resize', onResize);
    /* FH 2026-09-29 (layout shift): line the sidebar up in the same moment the filter app draws it, before the browser
       paints, rather than 30ms later. Moving it after it had been painted counted as a layout shift (CLS). */
    new MutationObserver(function () { try { align(); } catch (e) {} schedule(); }).observe(document.documentElement, { childList: true, subtree: true });
    window.addEventListener('load', schedule);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();